import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MCard, MGrid, MSelect} from "components/Shared";
import { ACTION_DOWNLOAD } from "components/Shared/MGrid.tsx";
import { getBonusWeeks } from "requests/payPeriods";
import { DATA_TYPE_NUMBER, DATA_TYPE_MONEY} from "typeConstants/dataTypes";
import { getPaySummary } from "requests/qualityAssurance/index.ts";
import { InputLabel } from "@material-ui/core";

const qaMacGridDef = [
  { name: "Pay Period", dataSource: "payPeriod.fromToDisplay", width: 225 },
  { name: "Total MAC", dataSource: "macTotal", dataType: DATA_TYPE_MONEY, width: 90 },
  { name: "Production Hours", dataSource: "productionHours", dataType: DATA_TYPE_NUMBER, width: 130 },
  { name: "Hours Worked", dataSource: "totalHoursWorked", dataType: DATA_TYPE_NUMBER, width: 125 },
  { name: "MAC Bonus", dataSource: "macBonus", dataType: DATA_TYPE_MONEY, width: 90 },
].map(c => ({ key: c.name, ...c }));

const QAMacCard = ({
    internetUserId,
  }) => {
  const mounted = useRef(true);
  const [payPeriodBonusWeeks, setPayPeriodBonusWeeks] = useState();
  const [selectedPayPeriod, setSelectedPayPeriod] = useState();
  const [payrollSummary, setPayrollSummary] = useState();
  
  // when the payperiod is changed
  useEffect(() => {
    if (selectedPayPeriod) {
      setPayrollSummary(null);
      getPaySummary(internetUserId, selectedPayPeriod.value, setPayrollSummary, mounted);
    }
  }, [selectedPayPeriod]);

  // when we get the list of pay periods
  const onPayPeriodsReceived = pp => {
    let mapped = pp.map(p => ({ label: p.fromToDisplay, value: p.payPeriodId, isClosed: p.isClosed }));
    setPayPeriodBonusWeeks(mapped);
    if (selectedPayPeriod) {
      setSelectedPayPeriod(mapped.find(m => m.value === selectedPayPeriod.value));
    } else {
      setSelectedPayPeriod(mapped[0]);
    }
  };

  // get the payperiods bonus weeks
  const getPayPeriods = () => getBonusWeeks(onPayPeriodsReceived, mounted);

  useEffect(() => {
    // get bonus weeks
    getPayPeriods();
    return () => { mounted.current = false; };
  }, []);

  return (
    <MCard className="qa-user-mac-card" title="MAC">
      <div className="bonus-week">
        <InputLabel id="bonusWeekLabel">Bonus Weeks:</InputLabel>
        <MSelect
          label="Bonus Weeks"
          value={selectedPayPeriod}
          onChange={setSelectedPayPeriod}
          options={payPeriodBonusWeeks}
          isClearable={false}
        /> 
      </div>
      {payrollSummary && 
      <MGrid
        height={260}
        displayNumOfItemsFound={false}
        headerText={"MAC Bonus: $" + payrollSummary.reduce((x, totalMac) => x + totalMac.macBonus, 0).toFixed(2)}
        columnDefinitions={qaMacGridDef}
        draggableColumns={false}
        data={payrollSummary}
        actions={[{ code: ACTION_DOWNLOAD }]}
        disableFilters
      />}
    </MCard>
  ); 
};

QAMacCard.propTypes = {
  internetUserId: PropTypes.number.isRequired,
};
  
export default connect()(QAMacCard);
